import { type RouteRecordRaw } from 'vue-router'

export interface CreateAuthRoutesOptions {
  RouteName: {
    signIn: string
    oAuth2Callback: string
    loggedOut: string
    signOut: string
  }
}

export function createAuthRoutes(options: CreateAuthRoutesOptions): readonly RouteRecordRaw[] {
  return [
    {
      path: '/sign-in',
      name: options.RouteName.signIn,
      component: () => import('../views/auth-sign-in.vue'),
      meta: {
        allowPublicEntrance: true
      }
    },
    {
      path: '/sign-out',
      name: options.RouteName.signOut,
      component: () => import('../views/auth-sign-out.vue'),
      meta: {
        allowPublicEntrance: true
      }
    },
    {
      path: '/oauth2-callback',
      name: options.RouteName.oAuth2Callback,
      component: () => import('../views/auth-callback.vue'),
      meta: {
        allowPublicEntrance: true
      }
      // redirect: () => '/'
    },
    {
      path: '/oauth2-logout',
      name: options.RouteName.loggedOut,
      component: () => import('../views/auth-logged-out.vue'),
      meta: {
        allowPublicEntrance: true
      }
    }
  ]
}
